export default function injectManifest() {
  const link = document.querySelector('#manifest-placeholder');
  if (link) {
    link.setAttribute('href', `${process.env.PUBLIC_URL}/manifest.json`);
  }
}
